import React, { useEffect, useState } from "react";
import { MapPin } from "lucide-react";

import BottomSheet from "../../app/BottomSheet";
import SearchInput from "src/components/app/SearchInput";
import Loader from "src/components/common/Loader";
import NoData from "src/components/app/NoData";

import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { getStatesListRequest } from "src/redux/slices/locationSlice";
import { State } from "src/types/location.types";

interface StateBottomSheetProps {
  show: boolean;
  handleClose: () => void;
  onSelect: (state: State) => void;
}

const StateBottomSheet: React.FC<StateBottomSheetProps> = ({
  show,
  handleClose,
  onSelect,
}) => {
  const [searchText, setSearchText] = useState("");
  const dispatch = useAppDispatch();
  const { states } = useAppSelector((state) => state.location);

  useEffect(() => {
    getStatesList();
  }, []);

  useEffect(() => {
    // console.log("debouncedSearchText", debouncedSearchText);
  }, [searchText]);

  useEffect(() => {
    // if (debouncedSearchText) {
    getStatesList();
    // }
  }, [searchText]);

  const getStatesList = () => {
    try {
      const payload = {
        search: searchText,
      };
      new Promise((resolve, reject) => {
        dispatch(
          getStatesListRequest({
            payload,
            resolve,
            reject,
          })
        );
      });
    } catch (error) {
      console.error("error", error);
    }
  };

  return (
    <BottomSheet
      show={show}
      title="Select Doctor's State"
      handleClose={handleClose}
    >
      <div className="flex flex-col p-4 gap-4">
        <SearchInput
          name="state"
          label="State name"
          type="text"
          placeholder="Enter state name"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

        <div className="h-[300px] overflow-y-auto">
          {states?.isLoading ? (
            <div className="flex justify-center items-center h-full">
              <Loader size="lg" color="primary" />
            </div>
          ) : states?.data?.length > 0 ? (
            states?.data?.map((state) => (
              <button
                key={state?.state_master_id}
                className="w-full px-4 py-2 hover:bg-gray-50 text-left text-md text-gray-700 border-b border-gray-200"
                onClick={() => {
                  onSelect(state);
                  handleClose();
                }}
              >
                {state?.state_name}
              </button>
            ))
          ) : states?.data?.length === 0 && !states?.isLoading ? (
            <NoData
              icon={<MapPin />}
              title="No states found"
              className="pb-8"
            />
          ) : null}
        </div>
      </div>
    </BottomSheet>
  );
};

export default StateBottomSheet;
